import { render, staticRenderFns } from "./UserBlacklistModal.vue?vue&type=template&id=88054940&"
import script from "./UserBlacklistModal.vue?vue&type=script&lang=js&"
export * from "./UserBlacklistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports